<template>
  <FormContainer withoutDivider>
    <template #title>Informations de facturation</template>
    <template #content>
      <div class="form__bloc">
        <WrapperInput
          label="N° de brouillon proforma groupée"
          :modelValue="model?.id.toString()"
          class="col-9 col-md-18 col-sm-36"
          :disabled="true"
        />
        <WrapperInput
          :modelValue="model?.reference"
          label="Référence proforma groupée"
          class="col-9 col-md-18 col-sm-36"
          :disabled="true"
        />
        <WrapperInput
          v-model:modelValue="referenceExterne"
          label="Référence interne (adhérent)"
          hint="30 caractères maximum"
          class="col-9 col-md-18 col-sm-36"
          :readonly
          :required="meta?.referenceExterne?.$status === PropertyStatus.Required"
          :alertLabel="meta?.referenceExterne?.$messageErreurDirty"
          :maxlength="30"
        />
      </div>
      <div class="form__bloc">
        <WrapperInput
          id=""
          :modelValue="model?.etablissementAdherent.denomination"
          label="Raison sociale / Nom"
          class="col-9 col-md-18 col-sm-36"
          :disabled="true"
        />
      </div>
      <div class="form__bloc">
        <WrapperInput
          id=""
          :modelValue="model?.etablissementAdherent.adresse?.voie"
          label="Adresse"
          class="col-9 col-md-18 col-sm-36"
          :disabled="true"
        />
        <WrapperInput
          id=""
          :modelValue="model?.etablissementAdherent.adresse?.codePostal"
          label="Code postal"
          class="col-9 col-md-18 col-sm-36"
          :disabled="true"
        />
        <WrapperInput
          id=""
          :modelValue="model?.etablissementAdherent.adresse?.commune"
          label="Ville"
          class="col-9 col-md-18 col-sm-36"
          :disabled="true"
        />
      </div>
      <div class="form__bloc">
        <WrapperInput
          id=""
          label="SIRET"
          :modelValue="model?.etablissementAdherent.siret.valeur"
          class="col-9 col-md-18 col-sm-36"
          :disabled="true"
        />
        <WrapperInput
          id=""
          label="Type public"
          :modelValue="model?.typePublic"
          class="col-9 col-md-18 col-sm-36"
          :disabled="true"
        />
      </div>
      <div class="form__bloc">
        <WrapperDropdown
          class="col-9 col-md-18 col-sm-36"
          label="RIB"
          v-model:modelValue="rib"
          key-id="id"
          key-label="iban"
          :disabled="(model?.ribsEligibles.length ?? 0) === 0"
          :readonly
          :required="meta?.rib?.$status === PropertyStatus.Required"
          :alertLabel="meta?.rib?.$messageErreurDirty"
          :items="model?.ribsEligibles"
        />
        <BasicButton
          v-if="!readonly"
          label="Ajouter un RIB"
          class="col-9 col-md-18 col-sm-36"
          @click="redirectExterne(lienAjoutRIB)"
        />
      </div>
    </template>
  </FormContainer>
</template>

<script setup lang="ts">
  import { DEMANDE_STORE } from '@/features/interface/demande/shared/components'
import FormContainer from '@/features/interface/demande/shared/components/FormContainer.vue'
import { redirectExterne } from '@/features/shared/tools/url'
import { storeToRefs } from 'pinia'

  import { PropertyStatus } from '@/features/domaine/property-status'
import { computed, inject } from 'vue'

  const store = inject(DEMANDE_STORE)!.getStore('MODEL_PROFORMA')
  const { model, meta, readonly } = storeToRefs(store)

  const lienAjoutRIB = computed(() => {
    return import.meta.env.VITE_SELFE_RIB
  })

  const referenceExterne = store.setupFieldWithKey<string>('referenceExterne', true)

  const rib = store.setupFieldWithOptions<number | null | undefined>({
    getValue: () => model.value?.rib?.id,
    setPatch: (patch, value) => {
      if (!value) {
        patch.rib = null
      } else {
        patch.rib = patch.ribsEligibles.find(item => item.id === value)
      }
    }
  })

</script>
